import { AccountData, AccountType } from "../../../models/AccountData";
import { FeatureUseLimitCalculator } from "../../../models/featureUseLimits/FeatureUseLimitsCalculator";
import {
  FeatureUseStatus,
  OrgFeatures,
} from "../../../models/featureUseLimits/FeatureUseLimitsData.const";
import { LocationData } from "../../../models/LocationData";

export const canEditFacilityBasicInfo = (
  me: AccountData | undefined,
  locationData: LocationData
) => {
  if (locationData.has_lodging) {
    return false;
  }

  if (me?.type === AccountType.ADMIN || me?.type === AccountType.LOC_ADMIN) {
    return true;
  }

  if (me?.type === AccountType.ORG_ADMIN) {
    return (
      FeatureUseLimitCalculator.getFeatureUseStatus(
        OrgFeatures.UPDATE_LOCATION_PROFILE,
        me.organization?.commonFeatureUseLimit
      ) === FeatureUseStatus.CAN_USE
    );
  }

  return false;
};
